import type { PageDetails, PaginationDetails } from '../../types.ts';

export enum PaginationDefaultValue {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export interface TablePaginationProps {
  className?: string;
  info: PageDetails;
  pagination: PaginationDetails;
  isLoading: boolean;
  dataTestId?: string;
}

export type UsePageInfoProps = {
  page: number;
  perPage: number;
  total: number;
};
export type UsePageInfoReturnType = PageDetails;
export type UsePaginationReturnType = PaginationDetails;
